export default {
  duplicatedWord: 'Ya has ingresado ese valor',
  wordsLimitReached: 'Ya has ingresado el máximo permitido'
}

export const en = {
  duplicatedWord: 'You have already entered this value',
  wordsLimitReached: 'You have already entered the maximum allowed values'
}

export const ca = {
  duplicatedWord: 'Ja has ingressat aquest valor',
  wordsLimitReached: 'Ja has ingressat el màxim de valors permès'
}
